export type OnboardingFileErrorCode = "too-large" | "unsupported-type";

export type ValidateOnboardingFileResult =
	| { errorCode?: undefined; ok: true }
	| { errorCode: OnboardingFileErrorCode; ok: false };

export const MAX_ONBOARDING_FILE_BYTES = 20 * 1024 * 1024;
export const MAX_ONBOARDING_FILE_MB = Math.round(MAX_ONBOARDING_FILE_BYTES / (1024 * 1024));
export const ACCEPTED_ONBOARDING_FILE_EXTENSIONS = [".xlsx", ".xls", ".csv", ".zip"];

const hasAcceptedExtension = (fileName: string, extensions: readonly string[]): boolean =>
	extensions.some((extension) => fileName.toLowerCase().endsWith(extension));

const validateOnboardingFile = (
	file: File,
	extensions: readonly string[] = ACCEPTED_ONBOARDING_FILE_EXTENSIONS
): ValidateOnboardingFileResult => {
	if (!hasAcceptedExtension(file.name, extensions)) return { errorCode: "unsupported-type", ok: false };
	if (file.size > MAX_ONBOARDING_FILE_BYTES) return { errorCode: "too-large", ok: false };
	return { ok: true };
};

export default validateOnboardingFile;
